import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Navbar, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
export var nbsp = React.createElement("span", null, "\u00A0");
export function buildLogo(_a) {
    var href = _a.href, src = _a.src, width = _a.width, height = _a.height, className = _a.className, alt = _a.alt;
    return (React.createElement(Navbar.Brand, null,
        React.createElement(Link, { to: href },
            React.createElement("img", { src: src, width: width, height: height, className: className, alt: alt }))));
}
function dropdownItemForLangs(i18nLangs, language, key, onLangChange) {
    function onButtonClick(lang) {
        return function () { return onLangChange(lang); };
    }
    return (React.createElement(NavDropdown.Item, { onClick: onButtonClick(language), key: key }, i18nLangs[language]));
}
export function dropdownForLangs(i18nLangs, currentLangKey, onLangChange) {
    var title = React.createElement("span", null,
        React.createElement(FontAwesomeIcon, { size: 'lg', icon: faLanguage }),
        nbsp,
        i18nLangs[currentLangKey]);
    return (React.createElement(NavDropdown, { alignRight: true, title: title, className: 'lang-dropdown d-flex align-items-center', id: 'lang-dropdown' }, Object.keys(i18nLangs).map(function (lang, key) { return dropdownItemForLangs(i18nLangs, lang, key, onLangChange); })));
}
//# sourceMappingURL=app-navbar-utils.js.map